module.exports = __webpack_public_path__ + "static/service-ig-11ee22a587890ce892ef8527482774c1.jpg";